import { auth } from '@/firebaseConfig';
import { API_ENDPOINTS } from '@/apiConfig';
import axiosClient from '@/axiosClient';

export function useCloseComplaint() {
    const closeComplaint = async (complaint, closeData) => {
        try {
            // Prepare the data for the API
            const closeTicketData = {
                ticket_id: complaint.id,
                message: closeData.message,
                deduction: closeData.deduction,
                score: closeData.score,
                user_id: auth.currentUser.uid,
                user_email: auth.currentUser.email,
                timestamp: new Date().toISOString()
            };

            // Call the API endpoint to close the ticket
            const response = await axiosClient.put(API_ENDPOINTS.closeTicket, closeTicketData);
            
            // Return the updated complaint from the API response
            return response.data;
            
        } catch (error) {
            console.error('Error closing complaint:', error);
            throw error;
        }
    };

    return {
        closeComplaint
    };
}
